import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TOKEN_KEY = "cass_token";
export const setAuthToken = (t) => { if (t) localStorage.setItem(TOKEN_KEY, t); };
export const clearAuthToken = () => localStorage.removeItem(TOKEN_KEY);
export const getAuthToken = () => localStorage.getItem(TOKEN_KEY);

const api = axios.create({ baseURL: API, withCredentials: true });

// Attach the JWT as a Bearer fallback so auth works even when the browser
// doesn't send the cross-site SameSite=None cookie (e.g. some uploads / custom domains).
api.interceptors.request.use((config) => {
  const t = getAuthToken();
  if (t) config.headers = { ...config.headers, Authorization: `Bearer ${t}` };
  return config;
});

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export const gbp = (n) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(Number(n || 0));

export default api;
